// if the url failed then record it return if meet it again.
const failedUrlRecord: string[] = [];
export function setupImageErrorCallback() {
  document.addEventListener(
    "error",
    function (event: ErrorEvent) {
      if (
        event.target instanceof HTMLImageElement &&
        event.target.parentNode instanceof HTMLPictureElement
      ) {
        const sourceEle = event.target.parentNode.children.item(0);
        const backupSrc = event.target.src;
        if (sourceEle && sourceEle instanceof HTMLSourceElement) {
          if (failedUrlRecord.includes(sourceEle.srcset)) return;
          failedUrlRecord.push(sourceEle.srcset);
          sourceEle.srcset = backupSrc;
        }
      }
    },
    true
  );
}
